import { render, staticRenderFns } from "./ItemDetailOpg.vue?vue&type=template&id=769f2d40&scoped=true"
import script from "./ItemDetailOpg.vue?vue&type=script&lang=js"
export * from "./ItemDetailOpg.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailOpg.vue?vue&type=style&index=0&id=769f2d40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f2d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769f2d40')) {
      api.createRecord('769f2d40', component.options)
    } else {
      api.reload('769f2d40', component.options)
    }
    module.hot.accept("./ItemDetailOpg.vue?vue&type=template&id=769f2d40&scoped=true", function () {
      api.rerender('769f2d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetailOpg.vue"
export default component.exports